import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUserStore } from "@/stores";
import { AGENT_ROLES } from "@/utils";
import { ROUTES } from "./routes";

interface PublicRouteProps {
  children?: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { token, isTwoFaAuthenticated, user } = useUserStore();
  const location = useLocation();
  const isAuthenticated = Boolean(token && isTwoFaAuthenticated);

  if (
    isAuthenticated &&
    user &&
    location.pathname !== ROUTES.twoFactorAuthSetup
  ) {
    const roleDestinations: Record<string, string> = {
      [AGENT_ROLES.CALL_CENTER_AGENT]: ROUTES.newIntake,
      [AGENT_ROLES.DATA_ENTRY_AGENT]: ROUTES.casesList,
      [AGENT_ROLES.ADMINISTRATOR]: ROUTES.casesList,
    };

    const destination = roleDestinations[user.role];

    if (destination) {
      return <Navigate to={destination} replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
};
